import { render, staticRenderFns } from "./contradictionShow.vue?vue&type=template&id=6835e874&"
import script from "./contradictionShow.vue?vue&type=script&lang=js&"
export * from "./contradictionShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports